import React, { useEffect, useRef, useContext } from "react";
import Search from "@arcgis/core/widgets/Search";

import { MapContext } from "../../../context/MapContext";

function AppSearch() {
  const searchDiv = useRef(null);
  const [map] = useContext(MapContext);

  useEffect(() => {
    if (searchDiv.current && map) {
      new Search({
        container: searchDiv.current,
        view: map?.view,
        showInfoWindowOnSelect: false,
        enableHighlight: false,
        enableButtonMode: true,
      });
    }
  }, [map]);

  return <div className="appSearch" ref={searchDiv} />;
}

export default AppSearch;
